<p-tabs [value]="currentTab" (valueChange)="onTabSelect($event)">
  <p-tablist>
    @for (tab of tabs; track tab.id) {
      <p-tab [value]="tab.id">{{ tab.labelKey | translate }}</p-tab>
    }
  </p-tablist>
  <p-tabpanels>
    @for (tab of tabs; track tab.id) {
      <p-tabpanel [value]="tab.id">
        @if (currentTab === tab.id && hasContent(tab)) {
          <ng-container *ngTemplateOutlet="getContent(tab)"></ng-container>
        }
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
